<!-- 课程首页信息 -->
<template>
    <div>
      <div class="course_index_t">
        <el-row>
          <el-image style="width: 243px;height: 140px;float: left;margin-right: 20px;border: 1px solid #E1E1E1;" :src="courseInfo.teacherOpenCourseCover"></el-image>
          <p class="fontB" style="margin-top:0 ;">{{courseInfo.courseInfoName}}</p>
          <el-row class="courseInfoContent" style="line-height: 27px;word-break:break-all" v-html="courseInfo.courseInfoContent"></el-row>
        </el-row>
        <el-row class="content_block mb30">
          <el-row class="title_head">
            <span class="class_img">
              <el-image class="title_img" :src="yulan"></el-image>
            </span>
            <span>课程数据预览</span>
          </el-row>
          <el-row class="pt40 pb40">
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="home"></el-image>
              <p>班级</p>
              <p class="num">{{courseInfo.classNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="xuesheng"></el-image>
              <p>学生</p>
              <p class="num">{{courseInfo.studentNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="kejian"></el-image>
              <p>课件</p>
              <p class="num">{{courseInfo.coursewareNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="shipin"></el-image>
              <p>视频</p>
              <p class="num">{{courseInfo.videoNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="timu"></el-image>
              <p>题目</p>
              <p class="num">{{courseInfo.subjectNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="anli"></el-image>
              <p>案例</p>
              <p class="num">{{courseInfo.caseNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="zuoye"></el-image>
              <p>作业</p>
              <p class="num">{{courseInfo.homeworkNum || 0}}</p>
            </el-col>
            <el-col :span="3" class="tc content_col">
              <el-image class="course_con_img" :src="kaoshi"></el-image>
              <p>考试</p>
              <p class="num">{{courseInfo.examNum || 0}}</p>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>
export default {
  name: 'courseIndex',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      kc1:require("../../../images/course/kc2.png"),
      yulan:require("../../../images/course/yulan@2x.png"),
      home:require("../../../images/course/Home@2x.png"),
      xuesheng:require("../../../images/course/xuesheng@2x.png"),
      kejian:require("../../../images/course/kejian@2x.png"),
      shipin:require("../../../images/course/shipin@2x.png"),
      timu:require("../../../images/course/timu@2x.png"),
      anli:require("../../../images/course/anli@2x.png"),
      zuoye:require("../../../images/course/zuoye@2x.png"),
      kaoshi:require("../../../images/course/kaoshi@2x.png"),
      courseInfo:{}
    }
  },
  created() {
    this.getCourseInfo();
  },
  mounted() {

  },
  methods: {
    getCourseInfo(){

      this.$get("/api/statisticalAnalysis/indexDetail.do",{teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfo = ret.data;
          this.$get("/api/teacherOpenCourse/getInfo.do",{teacherOpenCourseId:this.courseId}).then((ret) =>{
            if(ret.code == 0){
              this.courseInfo.courseInfoName = ret.data.teacherOpenCourseTitle;
              this.courseInfo.courseInfoContent = ret.data.teacherOpenCourseSummary;
              this.courseInfo.teacherOpenCourseCover = this.$isHttp(ret.data.teacherOpenCourseCover);
              this.courseInfo = Object.assign({},this.courseInfo);
            }else{
              this.$message({message: ret.msg,type: 'error'});
            }
          });
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },

  }
};
</script>
<style  lang="less">
  .course_index_t{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      border: 1px solid #E5E5E5;
      margin-top: 20px;
      .title_head{
        padding: 10px 20px;
        background-color: #EFF2F7;
      }
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .content_col{
        .course_con_img{
          width: 40px;
          height: 22px;
          cursor: pointer;
        }
        p{
          margin: 10px 0 0;
          cursor: pointer;
        }
        .num{
          margin-top: 20px;
          color: red;
        }
      }
    }
    .courseInfoContent{
      /deep/ p{
        margin: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/index.vue